import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import config from "../../envconfig";
import { UserContext } from "../common/UserContext";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import { IoCaretDownOutline, IoCaretUpOutline } from "react-icons/io5";

const Rsn = () => {
  const [randomNo, setRandomNo] = useState("");
  const [journeyData, setJourneyData] = useState([]);
  const [productName, setProductName] = useState(null);
  const [products, setProducts] = useState([]);
  const [expandedShipmentCode, setExpandedShipmentCode] = useState(null);
  const { UM_CompanyID } = useContext(UserContext);
  const [tableProduct, settableProduct] = useState();
  const [tableRsn, settableRsn] = useState();
  const [selectedProductId, setSelectedProductId] = useState("");
///===============================
const [rsnError, setRsnError] = useState(false);
const [productError, setProductError] = useState(false);

///===============================
  const options = Array.isArray(products)
    ? products.map((product) => ({
        label: product.PL_ProductName,
        value: product.PL_ProductName,
      }))
    : [];

  console.log("OPTIONS-", products);

  // const fetchJourneyData = () => {
  //   if (randomNo.length === 0) {
  //     toast.warning("Please Enter RSN");
  //     return;
  //   }
  //   if (productName.length === 0) {
  //     toast.warning("Please select product");
  //     return;
  //   }
  //   settableProduct(productName);
  //   settableRsn(randomNo);
  //   axios
  //     .get(
  //       `${config.API_URL}/api/product-journey/${randomNo}/${selectedProductId}`
  //     )
  //     .then((response) => {
  //       console.log(response.data);
  //       setJourneyData(response.data);
  //     })
  //     .catch((error) => console.error("Error fetching journey data:", error));
  // };

  const fetchJourneyData = () => {
  let hasError = false;

  if (randomNo.trim().length === 0) {
    setRsnError(true);
    hasError = true;
  } else {
    setRsnError(false);
  }

  if (!productName || !productName.value) {
    setProductError(true);
    hasError = true;
  } else {
    setProductError(false);
  }

  if (hasError) return;

  settableProduct(productName);
  settableRsn(randomNo);

  axios
    .get(`${config.API_URL}/api/product-journey/${randomNo}/${selectedProductId}`)
    .then((response) => {
      console.log(response.data);
      setJourneyData(response.data);
    })
    .catch((error) => console.error("Error fetching journey data:", error));
};

  useEffect(() => {
    fetch(`${config.API_URL}/productnames/${UM_CompanyID}`)
      .then((response) => response.json())
      .then((data) => {
        console.log("PRODUCTS RESPONSE:", data);
        // Validate and set products
        setProducts(data.PL_ProductName);
      })
      .catch((error) => console.error("Error fetching product names:", error));
  }, [UM_CompanyID]);

  const getEventName = (status, index, journeyData) => {
    if (status === 21) {
      // Check the previous status to determine the context
      if (index > 0) {
        const prevStatus = journeyData[index - 1].RSNH_Status;
        if (prevStatus === 22) return "Inward - Disaggregates";
        if (prevStatus === 6) return "Outward - Disaggregates";
      }
      return "OUTWARD - Disaggregate";
    }
    return status === 22 ? "Outward" : status === 6 ? "Inward" : "Unknown";
  };

  const groupByShipmentCode = (data) => {
    return data.reduce((acc, stage, index, array) => {
      const groupKey = `${stage.SHPH_ShipmentCode}-${stage.FromSCPName}-${stage.ToSCPName}`;
      const existing = acc.find((item) => item.groupKey === groupKey);
      const previousStage = index > 0 ? array[index - 1] : null; // Get the previous stage in the data

      if (existing) {
        existing.stages.push({
          ...stage,
          previousStatus: previousStage?.RSNH_Status,
        });
      } else {
        acc.push({
          groupKey,
          SHPH_ShipmentCode: stage.SHPH_ShipmentCode,
          FromSCPName: stage.FromSCPName,
          ToSCPName: stage.ToSCPName,
          stages: [{ ...stage, previousStatus: previousStage?.RSNH_Status }],
        });
      }
      return acc;
    }, []);
  };

  const groupedJourneyData = groupByShipmentCode(journeyData);

  const handleToggleCollapse = (shipmentCode) => {
    setExpandedShipmentCode(
      expandedShipmentCode === shipmentCode ? null : shipmentCode
    );
  };

  const handleProductChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setProductName(selectedOption); // Directly set the selected object
    const selectedProduct = products.find(
      (product) => product.PL_ProductName === selectedOption.value
    );
    if (selectedProduct) {
      console.log("ID = ", selectedProduct.PL_ProductId);
      setSelectedProductId(selectedProduct.PL_ProductId);
    }
  };

  console.log("JJ-", groupedJourneyData);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
    // logAction(`Select opened: ${selectName}`);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
    // logAction("Select closed");
  };
  return (
    <div className="main_container" style={{ fontFamily: "Arial, sans-serif" }}>
      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
      />
      <h1 className="formHeading">RSN History Report</h1>
      <div
        className="row mb-4 align-items-center d-flex"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* RSN Input */}
        <div
          style={{
            width: "40%",
          }}
        >
          <label>  RSN {rsnError && <span style={{ color: "red" }}>*</span>} </label>

          <input
            type="text"
            value={randomNo}
            // onChange={(e) => setRandomNo(e.target.value)}
             onChange={(e) =>
                setRandomNo(e.target.value.replace(/[^a-zA-Z0-9]/g, ""))
              }
            placeholder="Enter RSN"
            style={{
              width: "100%",
              padding: "8px",
              fontSize: "14px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              boxSizing: "border-box",
            }}
          />
        </div>
        <div style={{width: "40%", }}>
          <label>  Product Name {productError && <span style={{ color: "red" }}>*</span>}</label>

          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
            className="select-container"
          >
            <Select
              value={productName} // Ensure it's null or a valid object
              onChange={handleProductChange}
              options={options}
              styles={{
                container: (base) => ({
                  ...base,
                  width: "100%",
                }),
              }}
              placeholder="--Select--"
              onMenuOpen={() => handleSelectOpen("scpName")}
              onMenuClose={handleSelectClose}
            />
            <div className="icon-container">
              {isSelectOpen === "scpName" ? (
                <IoCaretUpOutline />
              ) : (
                <IoCaretDownOutline />
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            width: "20%",
            textAlign: "center",
          }}
        >
          <label>&nbsp;</label>
          <button
            onClick={fetchJourneyData}
            style={{
              width: "100%",
            }}
            className="search_btn"
          >
            SEARCH
          </button>
        </div>
      </div>

      {tableProduct && (
        <h5 className="formHeading" style={{ fontSize: "1.3em" }}>
          RSN - ({tableRsn}) - {tableProduct.label}
        </h5>
      )}

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "20px",
          fontSize: "14px",
          textAlign: "center",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#e4e4e4", color: "#465a64" }}>
            <th
              style={{
                border: "1px solid #e4e4e4",
                padding: "10px",
                fontWeight: "700",
              }}
            >
              Shipment Code
            </th>
            <th
              style={{
                border: "1px solid #e4e4e4",
                padding: "10px",
                fontWeight: "700",
              }}
            >
              From SCP Name
            </th>
            <th
              style={{
                border: "1px solid #e4e4e4",
                padding: "10px",
                fontWeight: "700",
              }}
            >
              To SCP Name
            </th>
            <th
              style={{
                border: "1px solid #e4e4e4",
                padding: "10px",
                fontWeight: "700",
              }}
            >
              Event
            </th>
            <th
              style={{
                border: "1px solid #e4e4e4",
                padding: "10px",
                fontWeight: "700",
              }}
            >
              Date
            </th>
            <th
              style={{
                border: "1px solid #e4e4e4",
                padding: "10px",
                fontWeight: "700",
              }}
            >
              Parent RSN
            </th>
            <th
              style={{
                border: "1px solid #e4e4e4",
                padding: "10px",
                fontWeight: "700",
              }}
            >
              Pack Size
            </th>
          </tr>
        </thead>
        <tbody>
          {groupedJourneyData.length > 0 ? (
            groupedJourneyData.map((group, index) => (
              <React.Fragment key={index}>
                {group.stages.map((stage, subIndex) => (
                  <tr
                    key={subIndex}
                    style={{
                      backgroundColor: subIndex % 2 === 0 ? "#f9f9f9" : "#fff",
                      color: "#465a64",
                    }}
                  >
                    {subIndex === 0 && (
                      <>
                        <td
                          rowSpan={group.stages.length}
                          style={{
                            border: "1px solid #ddd",
                            color: "#465a64",
                            padding: "10px",
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                          onClick={() => handleToggleCollapse(group.groupKey)}
                        >
                          {group.SHPH_ShipmentCode}
                        </td>
                        <td
                          rowSpan={group.stages.length}
                          style={{
                            border: "1px solid #ddd",
                            padding: "10px",
                            color: "#465a64",
                          }}
                        >
                          {group.FromSCPName}
                        </td>
                        <td
                          rowSpan={group.stages.length}
                          style={{
                            border: "1px solid #ddd",
                            padding: "10px",
                            color: "#465a64",
                          }}
                        >
                          {group.ToSCPName}
                        </td>
                      </>
                    )}
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        color: "#465a64",
                      }}
                    >
                      {getEventName(stage.RSNH_Status, subIndex, group.stages)}
                    </td>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        color: "#465a64",
                      }}
                    >
                      {/* {new Date(stage.RSNH_TimeStamp).toLocaleString()} */}
                      {/* {new Date(stage.RSNH_TimeStamp).toLocaleDateString('en-GB')} */}

                      {new Date(stage.RSNH_TimeStamp).toLocaleString('en-GB', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true,
                        })}

                    </td>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        color: "#465a64",
                      }}
                    >
                      {stage.RSNH_ParentRandomNo ? stage.RSNH_ParentRandomNo : "-"}
                    </td>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        color: "#465a64",
                      }}
                    >
                      {stage.RSNH_PackSize}
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))
          ) : (
            <tr>
              <td
                colSpan="7"
                style={{
                  border: "1px solid #ddd",
                  textAlign: "center",
                  padding: "8px",
                  color: "#465a64",
                  fontWeight: "500",
                }}
              >
                No Records Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Rsn;

//all set
